<template>
  <section class="container">
    <div class="header">
      <span class="category">{{ t('about_category') }}</span>
      <h2>{{ t('about_h2') }}</h2>
      <p>{{ t('about_p') }}</p>
    </div>

    <ColumnCards :features="features" />
  </section>
</template>

<script>
import ColumnCards from '@components/section/ColumnCards.vue'

export default {
  name: 'About',
  components: { ColumnCards },
  setup() {
    const features = [
      {
        icon: 'fa-solid fa-mug-hot',
        color: '40, 54, 24',
        headline: 'about_1_head',
        text: 'about_1_body',
      },
      {
        icon: 'fa-solid fa-envelope',
        color: '181, 23, 158',
        headline: 'about_2_head',
        text: 'about_2_body',
      },
      {
        icon: 'fa-solid fa-arrows-to-eye',
        color: '82, 183, 136',
        headline: 'about_3_head',
        text: 'about_3_body',
      },
      {
        icon: 'fa-solid fa-magnifying-glass',
        color: '255, 195, 0',
        headline: 'about_4_head',
        text: 'about_4_body',
      },
      {
        icon: 'fa-solid fa-bed',
        color: '116, 0, 184',
        headline: 'about_5_head',
        text: 'about_5_body',
      },
      {
        icon: 'fa-solid fa-door-open',
        color: '58, 217, 77',
        headline: 'about_6_head',
        text: 'about_6_body',
      },
      {
        icon: 'fa-solid fa-bullseye',
        color: '253, 47, 0',
        headline: 'about_7_head',
        text: 'about_7_body',
      },
    ]

    return {
      features,
    }
  },
}
</script>
